import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spacer } from '@guildeducationinc/recess';
import ThumbDownIcon from '@guildeducationinc/recess/icons/ThumbDownIcon';
import ThumbUpIcon from '@guildeducationinc/recess/icons/ThumbUpIcon';
import { useAiSummaryFeedback, useLocale } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
import styles from './AiSummary.module.scss';
export const AiFeedbackButtons = ({ field, clientId, userId, aiSummaryId, }) => {
    const { t } = useLocale();
    const [feedbackSent, setFeedbackSent] = useState({});
    const { aiSummaryFeedbackResponseItems, saveAiFeedback } = useAiSummaryFeedback({
        clientId,
        userId,
        id: aiSummaryId,
        pagination: {
            page: 1,
            pageSize: 20,
        },
    });
    useEffect(() => {
        const feedbackMap = aiSummaryFeedbackResponseItems.reduce((acc, item) => {
            // Only process items that have feedback with specific_fields
            if (item?.feedback && item.feedback.specificFields) {
                Object.entries(item.feedback.specificFields).forEach(([fieldName, fieldData]) => {
                    acc[fieldName] = fieldData.isCorrect === true ? 'up' : 'down';
                });
            }
            return acc;
        }, {});
        setFeedbackSent(feedbackMap);
    }, [aiSummaryFeedbackResponseItems]);
    const handleFeedback = async (field, isCorrect) => {
        // Get the latest feedback from the most recent response item
        // This ensures we're always working with the most up-to-date feedback
        const latestFeedback = aiSummaryFeedbackResponseItems.find(item => item?.feedback)
            ?.feedback || {
            specificFields: {},
        };
        // Create new feedback by merging existing specificFields with the new field
        const mergedFeedback = {
            ...latestFeedback,
            updated_at: new Date().toISOString(),
            specificFields: {
                ...latestFeedback.specificFields,
                [field]: {
                    isCorrect,
                    feedback: '',
                },
            },
        };
        // Optimistically update UI's feedback state
        setFeedbackSent(prev => ({
            ...prev,
            [field]: isCorrect ? 'up' : 'down',
        }));
        // Save the feedback and wait for it to complete
        try {
            await saveAiFeedback({
                aiSummaryId,
                feedback: mergedFeedback,
            });
        }
        catch (error) {
            // We failed to save the feedback, so we need to revert the UI
            setFeedbackSent(prev => ({
                ...prev,
                [field]: undefined,
            }));
        }
    };
    const FeedbackReceived = ({ up }) => {
        return (_jsxs("div", { className: styles.feedbackReceived, children: [up ? (_jsx(ThumbUpIcon, { className: styles.thumbsUpIcon, size: 24 })) : (_jsx(ThumbDownIcon, { className: styles.thumbsDownIcon, size: 24 })), _jsx(Spacer, { paddingRight: 4 }), t('Received')] }));
    };
    const FeedbackNeeded = () => {
        return (_jsxs(_Fragment, { children: [_jsx("button", { className: `${styles.feedbackBtn}`, onClick: () => handleFeedback(field, true), children: _jsx(ThumbUpIcon, { className: styles.thumbsUpIcon, size: 20 }) }), _jsx("button", { className: `${styles.feedbackBtn}`, onClick: () => handleFeedback(field, false), children: _jsx(ThumbDownIcon, { className: styles.thumbsDownIcon, size: 20 }) })] }));
    };
    return (_jsx("div", { className: styles.feedbackButtons, children: feedbackSent[field] === 'up' || feedbackSent[field] === 'down' ? (_jsx(FeedbackReceived, { up: feedbackSent[field] === 'up' })) : (_jsx(FeedbackNeeded, {})) }));
};
